import {Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';

/** Right-hand slide-in panel used for partner and referral details. */
@Component({
    selector: 'app-ref-drawer',
    template: `
        <div class="ref-overlay" [class.open]="open" (click)="close()"></div>
        <aside class="ref-drawer" [class.open]="open" role="dialog" [attr.aria-hidden]="!open" aria-labelledby="refDrawerTitle">
            <div class="ref-drawer-h">
                <div>
                    <h2 id="refDrawerTitle">{{title}}</h2>
                    <p class="ref-muted">{{sub}}</p>
                </div>
                <button class="ref-x" #closeBtn type="button" aria-label="Close" (click)="close()">×</button>
            </div>
            <div class="ref-drawer-b">
                <ng-content></ng-content>
            </div>
        </aside>`
})
export class RefDrawerComponent implements OnChanges {
    @Input() open = false;
    @Input() title = '';
    @Input() sub = '';
    @Output() closed = new EventEmitter<void>();
    @ViewChild('closeBtn') closeBtn: ElementRef<HTMLButtonElement>;
    private returnFocus: HTMLElement;

    ngOnChanges(changes: SimpleChanges) {
        if (changes.open && this.open) {
            this.returnFocus = document.activeElement as HTMLElement;
            setTimeout(() => this.closeBtn && this.closeBtn.nativeElement.focus(), 50);
        }
    }

    @HostListener('document:keydown.escape')
    onEscape() {
        // Let an open ngb modal handle Escape first
        if (this.open && !document.querySelector('ngb-modal-window')) {
            this.close();
        }
    }

    close() {
        if (!this.open) {
            return;
        }
        this.closed.emit();
        if (this.returnFocus) {
            this.returnFocus.focus();
        }
    }
}
